// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__33jrP","large":"styles_large__2G8wP"};